import React, { memo } from "react";
import { connect } from "react-redux";

//Routes
import { Switch } from "react-router";
import { SnackbarProvider } from "notistack";

//Code Splitting
// import { asyncComponent } from "../hocs/asyncComponent";

//Components
import Footer from "../components/Footer";

// Contexts
import { ThemeContext } from "../components/Contexts";

// Pages
import AlarmsCurrent from "../pages/AlarmsCurrent";
import AlarmsHistory from "../pages/AlarmsHistory";
import Landing from "../pages/Landing";
import Points from "../pages/Points";
import PointPage from "../pages/PointPage";

// MUI
import { Theme } from "@material-ui/core";

// Components
import { Layout, StyledRoute } from "../components/Layout";
import Profile from "../pages/Profile";
import Alarms from "../pages/Alarms";

// Interface
interface IRoutes {
  profile: any;
  role: any;
  theme: Theme;
}

//Routes
export const LANDING = "/";

export const ALARMS = "/alarms";
export const ALARMS_CURRENT = "/alarms/current";
export const ALARMS_HISTORY = "/alarms/history";
export const CALENDARS = "/calendars";
export const CLIENTS = "/clients";
export const CLIMATE = "/climate";
export const DASHBOARD = "/dashboard";
export const DEVICE_ACCESS = "/deviceaccess";
export const HISTORY = "/history";
export const LIGHTS = "/lights";
export const POINT = "/point/:id?";
export const POINTS = "/points";
export const PROFILE = "/profile";

export const PERMISSIONS = "/permissions";
export const PERMISSIONS_GROUPS = "/permissions/groups";

export const ADMIN = "/admin";

const Routes = ({ profile, role, theme }: IRoutes) => {
  // Layout
  const { layout } = React.useContext(ThemeContext);

  return (
    <div style={{ background: theme.palette.background.paper }}>
      {/* Notifications */}
      <SnackbarProvider autoHideDuration={2000} maxSnack={3}>
        <>
          {/* Providers */}

          <Layout component={layout} />
          {/* Router */}

          <Switch>
            {/* Root */}
            {/* Global Routes */}
            <StyledRoute component={Landing} exact path={LANDING} />

            {/* /alarms */}
            <StyledRoute component={Alarms} exact path={ALARMS} />

            {/* alarms/current */}
            <StyledRoute
              component={AlarmsCurrent}
              exact
              path={ALARMS_CURRENT}
            />
            {/* alarms/history */}
            <StyledRoute
              component={AlarmsHistory}
              exact
              path={ALARMS_HISTORY}
            />

            {/* points */}
            <StyledRoute component={Points} path={POINTS} />

            {/* point/{id} */}
            <StyledRoute component={PointPage} path={POINT} />

            {/* Profile */}
            <StyledRoute component={Profile} exact path={PROFILE} />
          </Switch>
          <Footer />
        </>
      </SnackbarProvider>
    </div>
  );
};

export default connect((state) => ({
  // @ts-ignore
  profile: state.firebase.profile,
  // @ts-ignore
  role: state.firebase.profile.role,
}))(memo(Routes));
